exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bollets_skills[data-v-545c5a92]{display:flex;padding:0}.bollets_skills li[data-v-545c5a92]{padding:0 10px}.bollets_skills li span[data-v-545c5a92]{background:#c7d2ff;border-radius:35px;height:auto!important;padding:3px 10px!important;color:var(--base-color)}", ""]);

// exports
